import { createAction, props } from '@ngrx/store';
import { ServiceError, ServiceErrorAccountData } from '../../create-request/models/shared/ServiceError';
import { MappedStatusViewResponse } from '../../shared/models/StatusViewResponse';
import { AccountInfoResponse } from '../models/AccountInfo';
import { VerifyTaxWithholdingsResponse } from '../../shared/models/VerifyTaxWithholdingsResponse';
import { PALHeaderResponse } from '../models/PALHeaderResponse';

export const refresh = createAction(
    '[Account Info Header] Refresh Account Data',
    props<{ accountId: string }>()
);

export const loadAccountInfoSuccess = createAction(
    '[Account Info Header/API] Account Data Loaded Successfully',
    props<AccountInfoResponse>()
)
export const loadPalAccountInfoSuccess = createAction(
    '[Account Info Header/API] PAL Account Data Loaded Successfully',
    props<PALHeaderResponse>()
)

export const loadAccountInfoFailure = createAction(
    '[Account Info Header/API] Account Data NOT Loaded',
    props<{ errorMsg: string}>()
)

export const loadAccountInfoServiceFailure = createAction(
    '[Account Info Header/API] Account Data NOT Loaded Service Error',
    props<{ errorMsg: string}>()
)

export const loadIsDbsUserAndIsEmployee = createAction(
    '[eAuthorization Page - eAuth Table] Load isDbsUser and isEmployee',
    props<{isDbsUser: boolean, isEmployee: boolean}>()
)

export const loadUsername = createAction(
    '[Create Request/SLOA Page - Main Page] Load username',
    props<{userName: string}>()
)

export const updateUserContext = createAction(
    '[Context] Update User Context',
    props<{ context: string }>()
)

export const updateSubAccount = createAction(
    '[Context] Update Sub Account',
    props<{ accountId: string }>()
);

export const updateMasterAccount = createAction(
    '[Context] Update Master Account',
    props<{ masterAccount: string }>()
);

export const loadTransactions = createAction(
    '[Create Request/SLOA Page - Main Page] Load Transactions',
    props<{ accountId: string }>()
)

export const loadTransactionsSuccess = createAction(
    '[Create Request/SLOA Page - API] Transactions/Instructions Loaded Successfully',
    props<MappedStatusViewResponse>()
)

export const loadTransactionsFailure = createAction(
    '[Create Request/SLOA Page - API] Transactions/Instructions NOT Loaded',
    props<ServiceError>()
)

export const verifyTaxWithholdings = createAction(
    '[Account level TWE update] Verify tax withholdings',
    props<{ fedTaxRate: number, stateTaxRate: number }>()
)

export const verifyTaxWithholdingsSuccess = createAction(
    '[Account level TWE update] Successfully verified tax withholdings',
    props<{ response: VerifyTaxWithholdingsResponse }>()
)

export const verifyTaxWithholdingsFailure = createAction(
    '[Account level TWE update] Failed call to verify tax withholdings',
    props<ServiceErrorAccountData>()
)

export const editTweLinkClicked = createAction(
    '[Account level TWE update] Edit TWE link clicked'
)

export const submitTaxWithholdings = createAction(
    '[Account level TWE update] Submit tax withholdings',
    props<{ fedTaxRate: number, stateTaxRate: number }>()
)

export const submitTaxWithholdingsSuccess = createAction(
    '[Account level TWE update] Tax withholdings submitted successfully'
)

export const submitTaxWithholdingsFailure = createAction(
    '[Account level TWE update] Failed to submit tax withholdings',
    props<ServiceErrorAccountData>()
)

export const updateHeaderTaxRates = createAction(
    '[Account Info Header] Update Header Tax Rates',
    props<{ federalTaxRate: string, stateTaxRate: string }>()
)